<template>
    <div class="field">
        <md-input v-model="selectedOption" type="hidden" />
        <vue-select
            :reduce="(r) => r"
            label="code"
            :options="optionList"
            v-model="selectedOption"
            :searchable="$root.isDesktop"
            append-to-body
        >
            <template v-if="showTooltip" #option="{ code, description }">
                <span>{{ code }}</span>
                <md-tooltip md-direction="right">
                    <span>{{ description }}</span>
                </md-tooltip>
            </template>

            <template v-else #option="{ code }">
                {{ code }}
            </template>
        </vue-select>
    </div>
</template>
<script>
import { handleRequests, showErrorMessage } from '@/helpers';

export default {
    name: 'AccountCodeOptions',
    props: {
        selected: {
            type: String,
            default: null
        },
        isUpdate: { type: Boolean, default: false },
        enabled: { type: Boolean, default: true },
        accountCodeType: {
            type: String,
            default: 'expense'
        },
        showTooltip: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            optionList: [],
            isListLoading: Boolean,
            selectedOption: null,
            selectedOptionDescription: null
        };
    },
    async mounted() {
        await this.getList();
    },
    watch: {
        selected: {
            immediate: true,
            handler(newValue) {
                if (newValue && this.optionList) {
                    this.selectedOption = this.optionList.find((o) => o.code === this.selected);
                }
            }
        },
        selectedOption(newValue, oldValue) {
            this.optionSelected(newValue);
        },
        async accountCodeType() {
            await this.getList();
        }
    },
    methods: {
        async getList() {
            try {
                this.isListLoading = true;
                const endpoint = `/api/team-settings/account-codes/${this.accountCodeType}`;

                const response = await handleRequests(endpoint);
                this.optionList = response.data;
                if (this.isUpdate && this.selected && this.selected.trim().length > 0) {
                    this.selectedOption = this.optionList.find((o) => o.code === this.selected);
                }
                if (!this.optionList || this.optionList.length === 0)
                    this.optionList.push({ description: 'empty', code: null });
            } catch (error) {
                const message = 'Error in getting the account code list';
                showErrorMessage(this, message, error);
            }
            this.isListLoading = false;
        },
        optionSelected(value) {
            this.$emit('optionSelected', !value || value?.code === 0 ? null : value.code);
            this.$emit('optionDescriptionSelected', value?.description);
        }
    }
};
</script>
<style scoped>
.field {
    width: 100%;
}
</style>
